import { ReactElement } from 'react';
import { Skeleton, Typography } from '@mui/material';
import BigNumber from 'bignumber.js';

import { BorderedPaper } from 'modules/common/components/BorderedPaper';
import { DEFAULT_DECIMAL_PLACES } from 'modules/common/const';
import { useGlobalTranslation } from 'modules/i18n/hooks/useGlobalTranslation';

import { useStyles } from './useStyles';

interface IBaseStatProps {
  label: string;
  topRightContent?: ReactElement;
  value?: BigNumber;
  usdValue?: BigNumber;
}

export function BaseStat({
  label,
  topRightContent,
  value,
  usdValue,
}: IBaseStatProps): ReactElement {
  const { classes } = useStyles();
  const { t, keys } = useGlobalTranslation();

  return (
    <BorderedPaper className={classes.root}>
      <div className={classes.top}>
        <Typography className={classes.label} component="div" variant="body1">
          {label}
        </Typography>

        {topRightContent}
      </div>

      <div className={classes.amount}>
        <Typography component="div" fontSize={24} fontWeight={600}>
          {value ? (
            value.decimalPlaces(DEFAULT_DECIMAL_PLACES).toFormat()
          ) : (
            <Skeleton />
          )}
        </Typography>

        {usdValue && !usdValue?.isZero() && (
          <Typography
            color={theme => theme.palette.text.secondary}
            variant="body1"
          >
            {t(keys.unit.$, {
              value: usdValue.decimalPlaces(2).toFormat(),
            })}
          </Typography>
        )}
      </div>
    </BorderedPaper>
  );
}
